var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultAvatar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 661 661",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #e7eefb;\n      }\n\n      .st1 {\n        fill: #3e7efa;\n      }\n\n      .st2 {\n        fill: #fefefe;\n      }\n\n      .st3 {\n        fill: #3e7dfa;\n      }\n\n      .st4 {\n        fill: #a1cbf3;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M343.1,0c164.7-.6,313.8,145.1,317.9,309v47c-1.1,58.2-23.4,117.6-59.1,166.1-8.9,12-19.8,26.2-30.6,36.3-1.8,1.7-4,2.7-6.3,3.6l-2.8-4.5c-13.5-74.4-70.2-143.1-141.1-166.6-53.9,38.3-126.4,39-180.6,0-71.1,25.1-127.2,92.3-140.6,167.6l-2.8,4.5c-2.1-.8-4.2-1.6-5.8-3.2-10.9-10.6-21.4-24.4-30.3-36.8C24.2,471.2,1.5,409.3.2,346c.5-9.8-.7-20.3,0-30C3.9,144.3,154.5-1.4,326.1,0h17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M326.1,0C149.4,6.9,12.5,139.1.2,316V0h325.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M.2,346c2.7,12.9,3.1,26.2,5.3,39.2,11.3,67.1,44.6,129.9,91.7,177.8,2,.7,4,1.4,5.6,2.8,27.5,23.9,50.1,42.1,83.2,58.5,42.5,21,77.8,28.2,124.3,33.5,2.1.2,4,1.3,5.9,2.3.9.3.9.6,0,1H.2v-315Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M343.1,0h317.9v309l-4.3-33.2C631.9,131.1,514.3,19.3,368.5,2.1L343.1,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M661,356v305h-316.9c-.9-.3-.9-.6,0-1,2.2-1,4.4-2,6.8-2.3,30.6-3.2,55.7-6.1,85.3-16.1,50.5-17.1,83.2-41.5,122.6-76.2,1.8-1.6,4-2.5,6.2-3.4,48.9-49.7,79.8-105.1,91.7-174.8l4.3-31.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M344.1,660v1h-28v-1c8.2-2.9,19.8-2.9,28,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M565,562c-59.4,60.3-135.1,95.4-220.9,98-9,.3-19,.3-28,0-80.5-2.7-162.7-39.9-218.9-97,10.7-70.4,58.5-134.1,122.1-165.4,3.8-1.9,18.1-8.8,21.4-8.7s13.6,8.4,17.4,10.6c41.8,23.4,94,24.5,137.3,4.3s22.9-14.5,25.2-14.9c4-.6,21.8,8,26.5,10.4,60.9,31.8,107.5,94.2,117.9,162.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M321.9,134.3c104.3-7.3,175.2,107,122.3,197.4-51.3,87.6-182.7,84.2-229.6-5.7-43.4-83.2,14.4-185.2,107.3-191.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.d4d57adb7195d401c62d07026bc9d8b9.svg";
export { ForwardRef as ReactComponent };